import { useMemo } from 'react';
import { useFetchUserInfo } from './useFetchUserInfo';
export const useHasScope = scope => {
  const userInfoResult = useFetchUserInfo();
  return useMemo(() => Object.assign({}, userInfoResult, {
    data: userInfoResult.data && userInfoResult.data.userInfo.user.scopes.includes(scope)
  }), [scope, userInfoResult]);
};